import { injectIntl, type InjectedIntlProps } from "react-intl";

interface InputSelectButtonProps extends InjectedIntlProps {
  clearSelection: () => void;
  getToggleButtonProps: any;
  isOpen: boolean;
  isClearable: boolean;
  disabled?: boolean;
}

const InputSelectButton = ({
  clearSelection,
  disabled,
  getToggleButtonProps,
  isOpen,
  isClearable,
  intl,
}: InputSelectButtonProps) => {
  const {
    onClick: onClickToggleButton,
    "aria-haspopup": ariaHaspopup,
    "data-toggle": dataToggle,
    onKeyUp,
    onKeyDown,
    onBlur,
  } = getToggleButtonProps();

  const ariaLabel = isClearable
    ? intl.formatMessage({
        id: "clearAndOpenMenu",
        defaultMessage: "Clear selection and open menu",
      })
    : intl.formatMessage({ id: "openMenu", defaultMessage: "Open menu" });

  return (
    <button
      aria-label={ariaLabel}
      aria-haspopup={ariaHaspopup}
      data-toggle={dataToggle}
      onKeyUp={onKeyUp}
      onKeyDown={onKeyDown}
      onBlur={onBlur}
      className="sid-input-select-button"
      disabled={disabled}
      type="button"
      onClick={(event) => {
        if (typeof clearSelection === "function") clearSelection();
        if (typeof onClickToggleButton === "function") onClickToggleButton(event);
      }}
    >
      <svg
        viewBox="0 0 20 20"
        preserveAspectRatio="none"
        width={16}
        fill="transparent"
        stroke="#8E95A4"
        strokeWidth="1.1px"
        transform={isOpen ? "rotate(180)" : undefined}
      >
        <path d="M1,6 L10,15 L19,6" />
      </svg>
    </button>
  );
};

export const InputSelectButtonComponent = injectIntl(InputSelectButton);
